function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "OpenIcon"
}, React.createElement("path", {
  id: "icon/file/download_done_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 10.7L9.6 15.3L19 6L17 4L9.6 11.4L7 8.8L5 10.7ZM19 18H5V20H19V18Z",
  fill: "#828282"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/open_status.e15bebf3.svg";
export { SvgComponent as ReactComponent };